<template>
    <div :class="isMobile == 0 ? '' : 'ProjectOne_mobile'" class="ProjectOne">
        <div :class="isMobile == 0 ? '' : 'ProjectOne_box_mobile'" class="ProjectOne_box">
            <!-- 直接使用 computed 属性，无需 data 中的变量 -->
            <div class="ProjectOne_top" v-if="lang.fyType == 2">{{ BigType }}/{{
                lanType[0].language == 'en' ? lanType[0].content : lanType[1].content }}</div>
            <div class="ProjectOne_top" v-else>{{ BigType }}/{{
                lanType[0].language == 'zh' ? lanType[0].content : lanType[1].content }}</div>

            <!-- <div :class="isMobile == 0 ? '' : 'ProjectOne_title_mobile'" class="ProjectOne_title"
                v-if="lang.fyType == 2">{{
                    lanType[0].language == 'en' ? lanType[0].content : lanType[1].content }}</div>
            <div :class="isMobile == 0 ? '' : 'ProjectOne_title_mobile'" class="ProjectOne_title" v-else>{{
                lanType[0].language == 'zh' ? lanType[0].content : lanType[1].content }}</div> -->



            <div :class="isMobile == 0 ? '' : 'ProjectOne_title_mobile'" class="ProjectOne_title"
                v-if="lang.fyType == 2">{{
                    twoItem.translations.name.content }}</div>
            <div :class="isMobile == 0 ? '' : 'ProjectOne_title_mobile'" class="ProjectOne_title" v-else>{{ twoItem.name
                }}</div>


            <div :class="isMobile == 0 ? '' : 'ProjectOne_list_mobile'" class="ProjectOne_list">
                <!-- 用 projectData 渲染列表（示例） -->
                <div :class="isMobile == 0 ? '' : 'ProjectOne_itemg_mobile'" @click="goDetail(item.id)"
                    class="ProjectOne_item" v-for="(item, index) in projectData" :key="index">
                    <img :class="isMobile == 0 ? '' : 'ProjectOne_img_mobile'" class="ProjectOne_img"
                        :src="'https://app.choisiyachts.com' + getImg(item)" />
                    <div :class="isMobile == 0 ? '' : 'ProjectOne_type_mobile'" class="ProjectOne_type">{{
                        item.translations.name.content }}</div>
                </div>
            </div>
        </div>
        <bottom-text></bottom-text>
    </div>
</template>

<script>
import { proCategories, proList } from '../../request/api.js'
import router from '@/router';
import bottomText from './bottomText.vue';

export default {
    components: {
        bottomText
    },
    name: 'BrandStory',
    data() {
        return {
            lang: {},
            projectData: [], // 用于渲染视图的实际数据
            proType: '',
            lanType: JSON.parse(localStorage.getItem('lanType')),
            isMobile: 0,

            twoItem: null
        }
    },
    // 监听路由变化（包括 query 参数变化）
    watch: {
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true, // 关键：监听对象内部属性（如 Lang/fyType）的变化
            immediate: true // 可选：组件初始化时就执行一次监听逻辑（避免首次加载无数据）
        }
    },
    mounted() {
        this.twoItem = JSON.parse(localStorage.getItem('twoItem'))

        this.isMobile = localStorage.getItem('isMobile')
        console.log('组件挂载完成');
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        if (this.lang.fyType == 2) {
            this.getProList(this.$route.params.id, 'en');
        } else {
            this.getProList(this.$route.params.id, 'zh');
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage(); // 同步最新语言到响应式变量（触发 watch）
        });
    },
    computed: {
        // 正确获取命名路由参数（与路由配置中的 :type 和 :smalltype 对应）
        BigType() {
            return this.$route.params.type || '未知大类';
        },
        SmallType() {
            return this.$route.params.smalltype || '未知小类';
        },
        ParentId() {
            return this.$route.params.parent_id || '未知id'
        }
    },
    methods: {
        getImg(item) {
            for (let i = 0; i < item.images.length; i++) {
                if (item.images[i].image_type == 'interior') {
                    return item.images[i].image_url.split(',')[0]
                }
            }
            // return item.images[0].image_url.split(',')[0]
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
            if (this.lang.fyType == 2) {
                this.getProList(this.$route.params.id, 'en');
            } else {
                this.getProList(this.$route.params.id, 'zh');
            }
        },
        loadProjectData(language) {
            console.log('路由变化，刷新数据');
            // 正确获取命名参数
            const type = this.$route.params.type;
            const smalltype = this.$route.params.smalltype;
            const id = this.$route.params.parent_id;

            console.log(`刷新数据：type=${type}, smalltype=${smalltype}`);
            this.proType = '';
            // this.getProCategories(id, language);
        },
        // 跳转示例（添加时间戳 query 参数）
        getProList(category_id, language) {
            let data = {
                page: 1,
                limit: 9999,
                type: 2,
                category_id,
                language
            }
            console.log('获取产品列表：', data);
            if (this.lang.fyType == 2) {
                data.language = 'en'
            } else {
                data.language = 'zh'
            }
            proList(data).then((res) => {
                this.projectData = res.data.data;
                console.log(res);
            })
        },
        goDetail(id) {
            console.log(this.BigType, this.SmallType, this.proType, id)
            router.push({
                path: `/project/${this.BigType}/${this.SmallType}/${id}`
            });
        }
    }
}
</script>

<style>
/* .ProjectOne_box {
    padding-left: 100px;
    width: 1460px;
    margin: 60px auto;
}

.ProjectOne_top {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #021131;
    margin-bottom: 15px;
}

.ProjectOne_title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 36px;
    color: #021131;
    margin-bottom: 40px;
}

.ProjectOne_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.ProjectOne_item {
    margin-right: 20px;
    margin-bottom: 40px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ProjectOne_item:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.ProjectOne_img {
    width: 453px;
    height: 283px;
    margin-bottom: 20px;
}

.ProjectOne_type {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #021131;
    text-align: left;
} */
</style>
